var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"carry-out-my-diagnosis"}},[_c('v-container',{staticClass:"fill-height mb-5",class:{ 'pa-0': _vm.fluid },attrs:{"fluid":_vm.fluid}},[_c('action-prevention-diagnosis')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }